import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IAidasProject } from 'app/shared/model/ainnotateservice/aidas-project.model';
import { getEntities as getAidasProjects } from 'app/entities/ainnotateservice/aidas-project/aidas-project.reducer';
import { IAidasProperties } from 'app/shared/model/ainnotateservice/aidas-properties.model';
import { getEntities as getAidasProperties } from 'app/entities/ainnotateservice/aidas-properties/aidas-properties.reducer';
import { getEntity, updateEntity, createEntity, reset } from './aidas-project-property.reducer';
import { IAidasProjectProperty } from 'app/shared/model/ainnotateservice/aidas-project-property.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasProjectPropertyUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasProjects = useAppSelector(state => state.aidasProject.entities);
  const aidasProperties = useAppSelector(state => state.aidasProperties.entities);
  const aidasProjectPropertyEntity = useAppSelector(state => state.aidasProjectProperty.entity);
  const loading = useAppSelector(state => state.aidasProjectProperty.loading);
  const updating = useAppSelector(state => state.aidasProjectProperty.updating);
  const updateSuccess = useAppSelector(state => state.aidasProjectProperty.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-project-property' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasProjects({}));
    dispatch(getAidasProperties({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...aidasProjectPropertyEntity,
      ...values,
      aidasProject: aidasProjects.find(it => it.id.toString() === values.aidasProjectId.toString()),
      aidasProperties: aidasProperties.find(it => it.id.toString() === values.aidasPropertiesId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...aidasProjectPropertyEntity,
          aidasProjectId: aidasProjectPropertyEntity?.aidasProject?.id,
          aidasPropertiesId: aidasProjectPropertyEntity?.aidasProperties?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="ainnotategwApp.ainnotateserviceAidasProjectProperty.home.createOrEditLabel"
            data-cy="AidasProjectPropertyCreateUpdateHeading"
          >
            Create or edit a AidasProjectProperty
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="aidas-project-property-id" label="ID" validate={{ required: true }} />
              ) : null}
              <ValidatedField
                id="aidas-project-property-aidasProject"
                name="aidasProjectId"
                data-cy="aidasProject"
                label="Aidas Project"
                type="select"
                required
              >
                <option value="" key="0" />
                {aidasProjects
                  ? aidasProjects.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <ValidatedField
                id="aidas-project-property-aidasProperties"
                name="aidasPropertiesId"
                data-cy="aidasProperties"
                label="Aidas Properties"
                type="select"
              >
                <option value="" key="0" />
                {aidasProperties
                  ? aidasProperties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField label="Value" id="aidas-project-property-value" name="value" data-cy="value" type="text" />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/aidas-project-property" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasProjectPropertyUpdate;
